export const TaskReminderTypesEnum = {
  EMAIL: {
    key: [1],
    value: "email",
  },
  NOTIFICATION: {
    key: [2],
    value: "notification",
  },
  NOTIFICATION_AND_EMAIL: {
    key: [1, 2],
    value: "notification-and-email",
  },
};
